// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1nOHh","m-signature-pad--body":"styles__m-signature-pad--body___3oxXF","m-signature-pad--footer":"styles__m-signature-pad--footer___GlnMQ","description":"styles__description___3ipqF","button":"styles__button___2xRFX","clear":"styles__clear___1Ghlz","save":"styles__save___2dWTk","m-signature-pad":"styles__m-signature-pad___2WP8A","github":"styles__github___1yRON","taskCheckedIcon":"styles__taskCheckedIcon___16Nz-","taskClockIcon":"styles__taskClockIcon___2eV-A","taskPendingIcon":"styles__taskPendingIcon___3Y9J9"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/TaskIcon/styles.scss
// module id = YV0Z
// module chunks = client